import { JsonProperty } from '../../../models/utilities/json-property';

/**
 * How many orders were entered on a day, and on the same day of the week before
 */
export class EnteredDay {

    @JsonProperty({ toType: 'date' })
    public date : Date = new Date();

    // Today is only counted up to now
    public entered : number = 0;

    public enteredWeekBefore : number = 0;

}

/**
 * The orders entered on each of the last seven days
 */
export class OrdersEntered {

    // The oldest day first, and the last of them today
    @JsonProperty({ toClass: EnteredDay, designType: 'array' })
    public days : EnteredDay[] = [];

}
